import * as React from 'react'

const InstantArticleScriptTag = () => (
	<>{`<script async src="https://static.readpeak.com/js/rp-instant.js"></script>`}</>
)

export default InstantArticleScriptTag
